import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { type DeepPartial } from '@core';
import { type ChildClient } from '@models';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ClientManagementService {
  private http = inject(HttpClient);

  getClientAccessList(): Observable<ChildClient[]> {
    return this.http.get<{ data: ChildClient[]; }>('clients/v1/clients').pipe(map(data => data.data));
  }

  createChildClient(clientId: string, data: DeepPartial<ChildClient>): Observable<ChildClient> {
    return this.http
      .post<{ data: ChildClient; }>(`clients/v1/clients/${clientId}/children`, data)
      .pipe(map(data => data.data));
  }

  updateChildClient(clientId: string, clientClientId: string, data: DeepPartial<ChildClient>): Observable<ChildClient> {
    return this.http
      .patch<{
        data: ChildClient;
      }>(`clients/v1/clients/${clientId}/children/${clientClientId}`, data)
      .pipe(map(data => data.data));
  }

  updateClientRequireTotp(clientClientId: string, requireTotp: boolean): Observable<ChildClient> {
    return this.http
      .patch<{
        data: ChildClient;
      }>(`clients/v1/clients/${clientClientId}/require-totp`, { requireTotp })
      .pipe(map(data => data.data));
  }
}
